var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"water-level-chart"}},[_c('dv-border-box-6',[_c('div',{staticClass:"water-level-chart-title"},[_vm._v("本月已完成工单数量")]),_c('div',{staticClass:"chart-container"},[_c('dv-water-level-pond',{attrs:{"config":_vm.config}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }